import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalReceptacleLinkColumn,
    ExternalConsignmentLinkColumn,
    DurationColumnWithDay,
  } = columns(data);
  return [
    {
      Header: 'PREDES',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'predes.receptacleId').withWidth(270)),
        new DateTimeColumn('Despatch closed', 'predes.despatchClosedDate'),
      ],
    },
    {
      Header: 'PRECON',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'precon.consignmentId').withWidth(130)),
        new TextColumn('Last leg destination location', 'precon.lastLegDestinationLocation'),
      ],
    },
    {
      Header: 'CARDIT',
      columns: [
        new TextColumn('Consignment ID', 'cardit.consignmentId'),
        new DateTimeColumn('First leg planned departure', 'cardit.firstLegPlannedDeparture'),
        new TextColumn('Last leg destination location', 'cardit.lastLegDestinationLocation'),
        new TextColumn('Last leg conveyance reference', 'cardit.lastLegConveyanceReference'),
        new DateTimeColumn('Last leg planned arrival', 'cardit.lastLegPlannedArrival'),
      ],
    },
    {
      Header: 'Destination handover',
      columns: [
        new DateTimeColumn('Actual arrival', 'destinationHandover.actualArrival'),
        new DateTimeColumn('RESDIT 14', 'destinationHandover.resdit14'),
        new DateTimeColumn('RESDIT 23', 'destinationHandover.resdit23'),
        new DateTimeColumn('RESDIT 21', 'destinationHandover.resdit21'),
        new DateTimeColumn('MRD registration', 'destinationHandover.mrdRegistration'),
        new DateTimeColumn('RESCON', 'destinationHandover.rescon'),
        new DateTimeColumn('RESDES', 'destinationHandover.resdes'),
      ],
    },
    {
      Header: 'Tail',
      columns: [
        new DurationColumnWithDay('(MRD or 21 or 23) - RESDIT 14', 'tail.mrdOrResdit'),
        new DurationColumnWithDay('RESCON - (MRD or 21 or 23)', 'tail.resconOrMrd'),
        new DurationColumnWithDay('Tail', 'tail.tailTime'),
      ],
    },
  ];
};
